import { useState } from 'react';
import { Column } from '../Components/Tables/Table';

interface SortingState {
  direction: "asc" | "desc";
  column: { column_name: string };
}

export const useSorting = (onPageChange?: (page: number) => void) => {
  const [sortingData, setSortingData] = useState<SortingState>({
    direction: 'asc',
    column: { column_name: '' }
  });

  const handleSortChange = (sortColumn: Column | null, sortDirection: "asc" | "desc") => {
    setSortingData({
      direction: sortDirection,
      column: { column_name: sortColumn?.column_name || '' }
    });
    
    // Reset to page 1 when sorting changes
    if (onPageChange) {
      onPageChange(1);
    }
  };

  return {
    sortingData,
    handleSortChange
  };
}; 